module.exports = __webpack_public_path__ + "static/media/SchematicsOfPrimMulEnergy.18e26d40.gif";